import { useEffect, RefObject } from 'react';

/**
 * 바깥 영역 클릭 시 콜백 실행 (드롭다운 등 닫기용)
 * @param onOutsideClick - 바깥 클릭 시 실행할 콜백
 * @param refs - 클릭 감지 제외할 요소들의 ref (여러 개 전달 가능)
 */
export function useClickOutside(
  onOutsideClick: () => void,
  ...refs: RefObject<HTMLElement | null>[]
) {
  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      const target = e.target as Node;
      const isInside = refs.some((ref) => ref.current?.contains(target));
      if (!isInside) onOutsideClick();
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, [onOutsideClick]);
}
